import { NgModule } from '@angular/core';
import { NoContentComponent } from './no-content';
import { SharedModule } from '../../shared';
import { AuditPageComponent } from './audit-page.component';
import { AuditService } from '../../services/audit/audit.service';

/**
 * `AuditModule`
 */
@NgModule({
    imports: [
        SharedModule
    ],
    providers: [AuditService],
    declarations: [
        AuditPageComponent
    ]
})
export class AuditModule {
}



// WEBPACK FOOTER //
// ./src/app/pages/audit-page/audit.module.ts